import { useQuery } from 'react-query';

import { getPoapViewById as queryFn } from 'api/endPoints/getPoapViewById';
import { FilterReferenceKey } from 'api/queries/getFilterItemOptionsByRowType.query';
import { RowTypeKey } from 'api/queries/getRowTypeOptions.query';
import { QueryKeys } from 'api/queryKeys';

export const GET_POAP_VIEW_BY_ID_QUERY_KEY: QueryKeys = 'getPoapViewById' as const;

export const useQueryGetPoapViewById = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: [GET_POAP_VIEW_BY_ID_QUERY_KEY, params],
        queryFn: () => queryFn({ viewId: params.viewId }),
        enabled: Boolean(params.viewId),
        select: (response) => {
            return {
                ...response,
                viewRows: (response.viewRows ?? []).map((row) => {
                    const refs = row.filterItemReferences;
                    const filterItemReferences = refs == null ? [] : Array.isArray(refs) ? refs : [refs];
                    return { ...row, filterItemReferences };
                }),
            };
        },
    });
};

export interface QueryParams {
    viewId: number | undefined;
}

export interface FilterItemReference {
    value: string;
    label: string;
    brokenReferenceLink: boolean;
    activitiesCount?: number;
}

interface ViewRows {
    rowId: number;
    rowName: string;
    projectId: number;
    contractId: number;
    latestVersionId: number;
    compareVersionId: number;
    currentVersionDate: number;
    baselineVersionDate: number;
    rowType: RowTypeKey;
    filterItem: FilterReferenceKey;
    filterItemReferences: FilterItemReference[];
    rowOrder: number;
    //there are more fields [items] but we don't need them for now, we can add them when needed
}

export interface QueryFnResponse {
    public: boolean;
    viewId: number;
    viewName: string;
    viewOrder: null;
    viewRows: ViewRows[];
}

type QueryResponse = QueryFnResponse;
